import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { GetServicesListPayload } from "../../payload/GetServicesList/GetServicesListPayload";

const getServicesListFetch = (state: ServiceState, action: PayloadAction<GetServicesListPayload>) => {
    state.isLoading = true;
}

export default getServicesListFetch;